<template>
  <v-container grid-list-lg pt-0>
    <div style="margin-top: 17rem !important" v-if="isLoading2">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>
    <div class="" v-if="!isLoading2 && totalOtherDepartment.length !== 0">
      <v-layout row wrap>
        <v-flex
          md3
          xs12
          sm6
          v-for="(i, index) in totalOtherDepartment"
          :key="index"
        >
          <v-card flat color="secondary">
            <v-card-text>
              <span
                class="white--text font-weight-bold"
                style="font-size: 20px; letter-spacing: -1px"
                >{{ i.department_name }} (ต้น)</span
              ><br />
              <v-layout
                row
                wrap
                justify-space-between
                align-end
                style="margin-top: 5px"
              >
                <v-flex sm12 xs12 md12 class="pb-0">
                  <span
                    class="display-2 white--text font-weight-bold lineheight30"
                    >{{ commaSeparateNumber(i.userPlantSum) }}</span
                  >
                </v-flex>
                <v-flex sm12 xs12 md12 style="text-align: right" class="pb-0">
                  <span
                    class="white--text font-weight-bold"
                    style="color: #605559 !important; font-size: 16px"
                    v-if="i.department_id == 1"
                  >
                    จำนวนผู้ปลูก
                    {{ commaSeparateNumber(i.numberofpeople + 26) }}
                    ราย</span
                  >
                  <span
                    class="white--text font-weight-bold"
                    style="color: #605559 !important; font-size: 16px"
                    v-else
                  >
                    จำนวนผู้ปลูก
                    {{ commaSeparateNumber(i.numberofpeople) }} ราย</span
                  >
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex md12>
          <v-flex md12 class="title font-weight-bold"
            >รายหน่วยงานกรมป่าไม้</v-flex
          >
          <div>
            <v-layout
              row
              wrap
              flex
              justify-center
              align-center
              fill-height
              v-if="isLoading && totalPlantByNursery.length == 0"
            >
              <v-progress-circular indeterminate color="primary" class="mt-4">
              </v-progress-circular>
            </v-layout>

            <v-card flat color="secondary" v-else>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex
                    lg4
                    md4
                    xs12
                    sm12
                    v-for="(i, index) in totalPlantByNursery"
                    :key="index"
                  >
                    <v-card class="pa-3" style="width: 100%">
                      <v-card-title
                        class="font-weight-bold pl-0 pa-1"
                        style="font-size: 18px"
                      >
                        {{ i.department_name }}
                      </v-card-title>
                      <v-divider></v-divider>
                      <table style="width: 100%">
                        <thead style="font-weight: 700">
                          <tr>
                            <td>หน่วยงาน</td>
                            <td style="width: 20%; text-align: end">
                              จำนวน (ต้น)
                            </td>
                            <td style="width: 20%; text-align: end">
                              ผู้ปลูก (ราย)
                            </td>
                          </tr>
                        </thead>
                        <!-- v-if="parseInt(j.userPlantSum) == 0 ? isShowAll : !isShowAll" -->
                        <!-- <div > -->
                        <tr
                          v-for="(j, index2) in i.sub_department"
                          :key="index2"
                        >
                          <td style="width: 50%">
                            {{ j.department_name }}
                          </td>
                          <td style="width: 25%; text-align: end">
                            <!-- v-show="
                      parseInt(i.sub_department[index2].userPlantSum) != 0 ?
                      isShowAll : !isShowAll " -->
                            {{ commaSeparateNumber(parseInt(j.userPlantSum)) }}
                          </td>
                          <td style="width: 25%; text-align: end">
                            {{ commaSeparateNumber(j.numberofpeople) }}
                          </td>
                        </tr>
                        <!-- </div>  -->
                      </table>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
      <!-- <pre> {{ totalPlantByNursery }}</pre> -->

      <!-- <v-layout row wrap v-if="filteredList.length === 0" justify-center mt-2>
        <v-flex xs1>
          <h2>ไม่พบข้อมูล</h2>
        </v-flex>
      </v-layout> -->
    </div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      totalPlant: "",
      totalPlantByNursery: [],
      totalOtherDepartment: [],
      isSort: true,
      isLoading: true,
      isLoading2: true,
      numberOfPeopleByTotlePlant: "",
      userRegister: "",
    };
  },
  created() {
    this.queryReportNurseryAll();
    this.queryOtherDepartmentAll();
    this.$emit("activeMenu", "department");
  },
  computed: {
    filteredList() {
      return this.totalPlantByNursery.filter((post) => {
        return post.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    queryReportNurseryAll() {
      return new Promise((resolve) => {
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/queryReportNurseryAll")
          .then((response) => {
            // console.log(response.data);
            this.totalPlantByNursery = response.data;
            resolve();
            this.isLoading = false;
          });
      });
    },
    queryOtherDepartmentAll() {
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryOtherDepartmentAll")
        .then((response) => {
          // console.log(response.data);
          this.totalOtherDepartment = response.data;
          this.isLoading2 = false;
        });
    },
    commaSeparateNumber(val) {
      while (/(\d+)(\d{3})/.test(val.toString())) {
        val = val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      }
      return val;
    },
    sort() {
      if (this.isSort) {
        this.isSort = false;
        return this.totalPlantByProvince.sort(function (a, b) {
          return b.userPlantSum - a.userPlantSum;
        });
      } else {
        this.isSort = true;
        return this.totalPlantByProvince.sort(function (a, b) {
          return a.userPlantSum - b.userPlantSum;
        });
      }
    },
  },
};
</script>

<style scoped>
.lineheight {
  line-height: 0.65 !important;
}
.lineheight30 {
  line-height: 40px !important;
}
</style>
